export default __webpack_public_path__ + "media/images/rabbit_ui_announce-a0043ffbc75907a247ff55db2bbe734d.png";